export const messages = {
  title: { id: 'admin/promotions.form.origin.title' },
  marketplace: { id: 'admin/promotions.form.origin.marketplace' },
  fulfillment: { id: 'admin/promotions.form.origin.fulfillment' },
  modal: {
    title: { id: 'admin/promotions.form.origin.warning.title' },
    content: { id: 'admin/promotions.form.origin.warning.content' },
    cancel: { id: 'admin/promotions.utils.cancel' },
    continue: { id: 'admin/promotions.utils.continue' },
  },
}
